import React, { useState } from 'react'
import { Text } from 'theme-ui'
import { Transition } from 'react-transition-group'

import {
  WebinarsAccordionStyled,
  WebinarsAccordionInnerStyled,
  WebinarsAccordionContentStyled,
  WebinarsAccordionContentContainerStyled,
  WebinarsAccordionContentItemStyled,
  WebinarsAccordionContentTextStyled,
  WebinarsAccordionHeadStyled,
  WebinarsAccordionHeadTextStyled,
  WebinarsAccordionContentDescStyled,
  WebinarsAccordionContentListHeadStyled,
  WebinarsAccordionContentListStyled,
  WebinarsAccordionHeadAdditionalsStyled,
  WebinarsAccordionContentListItemStyled,
  WebinarsAccordionContentCtaStyled,
  WebinarsAccordionHeadAdditionalsItemStyled,
  WebinarsAccordionHeadIconStyled
} from './styles'
import { transitionStyles } from './cfg'
import { IconArrowSmall, IconCalendar, IconTime } from '../../../assets/svg/index'
import { WebinarsAccordionProps } from './types'
import TimeInfo from './../../molecules/TimeInfo'
import Button from './../../atoms/Button'

const WebinarsAccordion: React.FC<WebinarsAccordionProps> = ({ data }) => {
  const [isAccordionActive, setIsAccordionActive] = useState('')

  const handleAccordionClick = (value: string): void => {
    isAccordionActive === value ? setIsAccordionActive('') : setIsAccordionActive(value)
  }

  return (
    <WebinarsAccordionStyled>
      <WebinarsAccordionInnerStyled>
        <WebinarsAccordionContentStyled as="div">
          {data &&
            data.map(({ key, title, dateLabel, timeLabel, content }) => {
              const isAccordionActiveState = isAccordionActive === key
              return (
                <WebinarsAccordionContentContainerStyled key={`${key}-tab`} onClick={() => handleAccordionClick(key)}>
                  <WebinarsAccordionHeadStyled isActive={isAccordionActiveState}>
                    <WebinarsAccordionHeadTextStyled
                      sx={{
                        variant: 'bodyMontserrat24'
                      }}
                    >
                      {title}
                    </WebinarsAccordionHeadTextStyled>
                    <WebinarsAccordionHeadAdditionalsStyled>
                      <WebinarsAccordionHeadAdditionalsItemStyled>
                        <TimeInfo icon={<IconCalendar />} title={dateLabel.name} value={dateLabel.value} />
                      </WebinarsAccordionHeadAdditionalsItemStyled>

                      <WebinarsAccordionHeadAdditionalsItemStyled>
                        <TimeInfo icon={<IconTime />} title={timeLabel.name} value={timeLabel.value} />
                      </WebinarsAccordionHeadAdditionalsItemStyled>
                    </WebinarsAccordionHeadAdditionalsStyled>
                    <WebinarsAccordionHeadIconStyled>
                      <IconArrowSmall />
                    </WebinarsAccordionHeadIconStyled>
                  </WebinarsAccordionHeadStyled>
                  <Transition in={isAccordionActiveState} timeout={150} appear>
                    {(state) => (
                      <WebinarsAccordionContentItemStyled
                        isActive={isAccordionActiveState}
                        style={{
                          ...transitionStyles[state]
                        }}
                      >
                        <WebinarsAccordionContentTextStyled>
                          <WebinarsAccordionContentDescStyled
                            as="p"
                            sx={{
                              variant: 'bodyMontserrat25'
                            }}
                          >
                            {content.description}
                          </WebinarsAccordionContentDescStyled>
                          <WebinarsAccordionContentListHeadStyled
                            as="p"
                            sx={{
                              variant: 'bodyMontserrat25'
                            }}
                          >
                            {content.heading}
                          </WebinarsAccordionContentListHeadStyled>
                          <WebinarsAccordionContentListStyled>
                            {content.list.map(({ key, text }) => (
                              <WebinarsAccordionContentListItemStyled {...{ key }}>{text}</WebinarsAccordionContentListItemStyled>
                            ))}
                          </WebinarsAccordionContentListStyled>
                          <WebinarsAccordionContentCtaStyled>
                            <Button variant="withArrow" {...content.cta} />
                            {/* <Text
                              sx={{
                                variant: 'bodyMontserrat7',
                                marginTop: '5px'
                              }}
                            >
                              {content.cta.caption}
                            </Text> */}
                          </WebinarsAccordionContentCtaStyled>
                        </WebinarsAccordionContentTextStyled>
                      </WebinarsAccordionContentItemStyled>
                    )}
                  </Transition>
                </WebinarsAccordionContentContainerStyled>
              )
            })}
        </WebinarsAccordionContentStyled>
      </WebinarsAccordionInnerStyled>
    </WebinarsAccordionStyled>
  )
}

export default WebinarsAccordion
